import script from "./PodcasterDashboardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcasterDashboardNew.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__